import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'firm-manager',
    pathMatch: 'full'
  },
  {
    path: 'firm-manager',
    canActivate: [AuthGuard],
    loadChildren: () => import('./firm-manager/firm-manager.module').then( m => m.FirmManagerPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'surveys/create',
    loadChildren: () => import('./surveys/create/create.module').then( m => m.CreatePageModule)
  }




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
